// @flow
import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@material-ui/core';
import CustomButton from '../CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CustomModal from '../CustomModal/CustomModal';
import {colors} from '../../assets/styles/colors';

import {Prompt, useHistory} from 'react-router-dom';

type Props = {
  when: boolean,
  title?: string,
  description?: string,
};
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 340,
    padding: theme.spacing(4, 1, 2, 1),
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
  },
  description: {
    marginTop: theme.spacing(1),
    textAlign: 'center',
    fontSize: '0.875rem',
    color: colors.grey800,
  },
  buttonRow: {
    marginTop: theme.spacing(2),
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  button: {
    minWidth: 100,
    // height: 40,
    // fontSize: '1rem',
    // fontWeight: 600,
    // padding: '6px 50px',
  },
  rootModal: {
    zIndex: '1400 !important',
  },
}));

export default function CustomExitPrompt(props: Props) {
  const {when, title, description} = props;
  const classes = useStyles();

  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [exitLocation, setExitLocation] = useState(null);
  const [exitAction, setExitAction] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  // useEffect(() => {
  //     if (exitLocation && exitAction==='POP' && dialogFinalizar===false && !confirmedNavigation) {
  //         window.history.forward()
  //     }
  // }, [dialogFinalizar]);

  const currentPath = useRef(null);
  useEffect(() => {
    if (!!currentPath) {
      currentPath.current = window.location.pathname;
    }
  }, []);

  const handleBlockedRoute = (nextLocation, action) => {
    if (
      !confirmedNavigation &&
      nextLocation.pathname !== '/login' &&
      nextLocation.pathname !== '/rol'
    ) {
      if (
        currentPath &&
        currentPath.current !== nextLocation.pathname &&
        action === 'POP'
      ) {
        window.history.forward();
      }

      setOpenModal(true);
      setExitLocation(nextLocation);
      setExitAction(action);

      return false;
    }
    return true;
  };

  const handleConfirmNavigation = () => {
    setOpenModal(false);
    setConfirmedNavigation(true);
  };

  useEffect(() => {
    if (confirmedNavigation && exitLocation) {
      if (exitAction === 'POP') history.goBack();
      else
        history.push({
          pathname: exitLocation.pathname,
          search: exitLocation.search,
        });
    }
  }, [confirmedNavigation, exitAction, exitLocation, history]);

  return (
    <>
      <Prompt when={when} message={handleBlockedRoute}></Prompt>
      <CustomModal
        open={openModal}
        handleCloseModal={handleCloseModal}
        classes={{
          root: classes.rootModal,
        }}
      >
        <div className={classes.root}>
          <Typography className={classes.title}>
            {title ? title : '¿Seguro que deseas salir sin guardar?'}
          </Typography>
          {description && (
            <Typography className={classes.description}>
              {description}
            </Typography>
          )}
          <div className={classes.buttonRow}>
            <CustomButton
              variant="contained"
              color="default"
              className={classes.button}
              onClick={handleCloseModal}
            >
              No
            </CustomButton>
            <CustomButton
              variant="contained"
              className={classes.button}
              onClick={handleConfirmNavigation}
            >
              Sí
            </CustomButton>
          </div>
        </div>
      </CustomModal>
    </>
  );
}

CustomExitPrompt.propTypes = {
  when: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};
